<template>
  <vPlotly
    :data="data"
    :layout="chart.layout"
    :id="chartId"
    v-bind="chart.options"
  ></vPlotly>
</template>

<script>
/*
  Plot component that calls on vue-plotly
*/
/* eslint-disable vue/multi-word-component-names */
import { Plotly as vPlotly } from 'vue-plotly';
import { mapGetters } from 'vuex';

export default {
  name: 'Plot',
  props: ['chartId', 'chartUUID'],
  components: {
    vPlotly,
  },
  data() {
    return {
      layoutDefault: {
        autosize: true,
      },
      optionsDefault: {
        responsive: true,
      },
    };
  },
  computed: {
    ...mapGetters('visualization/charts', {
      getChart: 'find',
      charts: 'list',
      chartsLength: 'count',
    }),
    ...mapGetters('visualization/traces', {
      getTraces: 'findByUUID',
      getTrace: 'find',
      isTabExists: 'exists',
      getInstruments: 'findSelectedInstruments',
    }),
    chartContainer() {
      if (this.chartsLength === 0) {
        return null;
      }
      return this.getChart(this.chartUUID);
    },
    chart() {
      if (this.chartContainer) {
        return this.chartContainer.chart;
      }
      return null;
    },
    data() {
      const data = this.getTraces(this.chartUUID);
      return data;
    },
  },
};
</script>

<style>
</style>
